<template>
  <div
    class="lane w-1/7 border-r border-gray-200 last:border-r-0"
    :class="{ 'bg-gray-50': !isOrderable, 'bg-accent-green-light': isToday }">
    <h3 class="text-2xl pb-2 pt-5 border-b border-gray-200 text-center text-black">
      <div class="flex justify-center items-center">
        {{ dayName }}
        <span v-if="isToday" class="w-3 h-3 bg-accent-green rounded-full ml-2" />
      </div>
      <span class="text-base">{{ dayFormatted }}</span>
    </h3>
    <div class="px-2">
      <slot />
      <OrderCard
        v-if="order"
        :order="order"
        :editable="isOrderable"
      />
      <Link
        v-if="order && !order.submitted && isOrderable"
        :href="route('order', { orderDate: orderSlug })"
        class="my-4 button p-1 lg:p-2 lg:pr-3 w-full text-sm text-center border-2 border-black flex items-center justify-center font-bold whitespace-nowrap transition-all bg-black text-white hover:opacity-70 active:opacity-1">
        bearbeiten
      </Link>
      <Link
        v-else-if="order && order.submitted && order.editable"
        :href="route('order', { orderDate: orderSlug })"
        class="my-4 button p-1 lg:p-2 lg:pr-3 w-full text-sm text-center border-2 border-black flex items-center justify-center font-bold whitespace-nowrap transition-all bg-black text-white hover:opacity-70 active:opacity-1">
        bearbeiten
      </Link>
      <template v-else-if="order && order.submitted">
        <Link
          v-if="$page.props.customerCanComplaint"
          :href="route('complaint-index', { order })"
          class="my-4 button-secondary p-1 lg:p-2 lg:pr-3 w-full text-sm text-center border-2 border-black flex items-center justify-center font-bold whitespace-nowrap transition-all bg-black border-black hover:opacity-70 active:opacity-1">
          Reklamationen
        </Link>
        <Link
          :href="route('order', { orderDate: orderSlug })"
          class="my-4 button p-1 lg:p-2 lg:pr-3 w-full text-sm text-center border-2 border-black flex items-center justify-center font-bold whitespace-nowrap transition-all bg-black text-white hover:opacity-70 active:opacity-1">
          Bestellung ansehen
        </Link>
      </template>
      <Link
        v-else-if="isOrderable"
        :href="route('order', { orderDate: orderSlug })"
        class="my-4 button p-1 lg:p-2 lg:pr-3 w-full text-sm text-center border-2 border-black flex items-center justify-center font-bold whitespace-nowrap transition-all bg-black text-white hover:opacity-70 active:opacity-1">
        Für diesen Tag bestellen
      </Link>
      <p
        v-if="isExcluded"
        class="text-center my-4 text-sm text-gray-500">
        Keine Lieferung
      </p>
    </div>
  </div>
</template>

<script>
import format from 'date-fns/format'
import isSunday from 'date-fns/isSunday'
import isToday from 'date-fns/isToday'
import isBefore from 'date-fns/isBefore'
import isSameDay from 'date-fns/isSameDay'
import deLocale from 'date-fns/locale/de'
import { Link } from '@inertiajs/inertia-vue3'

import OrderCard from './OrderCard'

export default {
  name: 'CalendarLane',
  components: { Link, OrderCard },
  inject: ['systemStatus'],
  props: {
    day: {
      type: Date,
      required: true
    },
    order: {
      type: Object,
      required: false,
      default: () => {}
    },
    excluded: {
      type: Array,
      required: false,
      default: () => []
    }
  },

  computed: {
    dayName() {
      return format(this.day, 'EEEEEE',  { locale: deLocale })
    },

    dayFormatted() {
      return format(this.day, 'dd.MM.')
    },

    isSunday() {
      return isSunday(this.day)
    },

    isToday() {
      return isToday(this.day)
    },

    nextOrderDay() {
      return this.systemStatus ? new Date(this.systemStatus.next_order_day) : new Date()
    },

    isOrderable() {
      return (!isBefore(this.day, this.nextOrderDay) || isSameDay(this.day, this.nextOrderDay)) && !this.isExcluded
    },

    isExcluded() {
      if (!this.excluded) {
        return false
      }

      if (isBefore(this.day, this.nextOrderDay)) {
        return false
      }

      return this.excluded.find(day => isSameDay(this.day, day)) !== undefined
    },

    orderSlug() {
      return format(this.day, 'yyyy-MM-dd')
    }
  }
}
</script>

<style scoped>
@media (hover: hover) {
  .button, .button-secondary {
    display: none;
  }

  .lane:hover .button,
  .lane:hover .button-secondary {
    display: block;
  }
}
</style>
